<template>
    <div style="text-align: left">
        <div class="list">物流管理</div>
        <div class="content">
            <div class="goods">
                <div style="width:100%">
                    学校名称：<el-input placeholder="请输入学校名称" class="input-with-select"
                        style="max-width: 300px;margin-right: 20px;"></el-input>
                    <el-button type="primary">搜 索</el-button>

                    <el-button style="margin-left: 20px" type="primary" plain>重置</el-button>
                    <hr style="margin-top: 20px" />
                    <div style="margin-top: 20px">
                        <el-button type="primary" plain >新增学校</el-button>
                        <!-- <el-button type="primary" plain>批量删除</el-button> -->
                    </div>
                </div>
                <br />

            </div>
            <br />
            <!-- <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange"
                    :cell-style="{}" header-align="center">
                    <el-table-column type="selection" width="55" align="center">
                    </el-table-column>
                    <el-table-column type="index" width="50" label="序号" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="schoolName" label="学校名称" width="300" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="province" label="省份" header-align="center" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="city" label="城市" width="100" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="area" label="区域" width="100" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="address" label="详细地址" width="300" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="text" size="small">详情</el-button>
                            <el-button type="text" size="small" @click="editorChild(scope.row)">编辑</el-button>
                            <el-button @click="deleteGoodsOne(scope.row)" type="text" size="small">删除</el-button>
                            <el-button @click="studentManagement(scope.row)" type="text" size="small">学生管理</el-button>
                            <el-button type="text" size="small" @click="batchManagement(scope.row)">批次管理</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div> -->
            <!-- <div class="block">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="queryList.pageNum" :page-size="queryList.pageSize"
                    layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
}
</style>